import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/**
 * Draw a custom shape.
 */
export var Shape = function Shape(options, context) {
  var render = options.render,
    rest = __rest(options, ["render"]);
  return function (points) {
    var _points = _slicedToArray(points, 1),
      _points$ = _slicedToArray(_points[0], 2),
      x0 = _points$[0],
      y0 = _points$[1];
    return render(Object.assign(Object.assign({}, rest), {
      x: x0,
      y: y0
    }), context);
  };
};
Shape.props = {
  defaultMarker: 'point',
  defaultEnterAnimation: 'fadeIn',
  defaultUpdateAnimation: 'morphing',
  defaultExitAnimation: 'fadeOut'
};